module.exports = __webpack_public_path__ + "img/selected0-min.e4e90ab5.png";